export default __webpack_public_path__ + "static/media/img2.8e9b41b9.png";